// src/components/Footer.js
import React from 'react';
import styles from './Footer.module.css';
// On importe les icônes dont on a besoin
import { FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';

function Footer() {
  return (
    <footer className={styles.footerSlim}>
      <ul className={styles.footerLinks}>
        <li><a href="/">Accueil</a></li>
        <li><a href="/Signesabreviations">Signes et Abréviations</a></li>
        <li><a href="/Elementsdegrammaire">Éléments de Grammaire</a></li>
        <li><a href="/Brevehistoire">Brève Histoire du Rwanda</a></li>
      </ul>
      <div className={styles.footerSocials}>
        {/* On utilise les composants d'icônes */}
        <a href="#/" aria-label="Facebook"><FaFacebookF /></a>
        <a href="#/" aria-label="Twitter"><FaTwitter /></a>
        <a href="https://www.instagram.com/editionssourcesdunil?igsh=MTF2MGZ1MXBjOXJoNg==" aria-label="Instagram"><FaInstagram /></a>
      </div>
      <p className={styles.footerNote}>
        © 2025 Éditions Sources du Nil. Tous droits réservés.
      </p>
    </footer>
  );
}

export default Footer;